"use strict";
/**
 * Created by Ning Jiang on 12/6/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameTweakerTest = void 0;
const BaseController_1 = require("../../../core/base/BaseController");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
class GameTweakerTest extends BaseController_1.BaseController {
    constructor() {
        super(true, "GameTweakTest");
        this._tweakValue1 = 10;
        this._tweakValue2 = 100;
        this.addTweakModuleSlider({
            text: "value1",
            minValue: 1,
            maxValue: 100,
            startValue: this._tweakValue1,
            onValueChangeCallback: (text, newValue) => this.onTweakValue1Changed(newValue)
        });
        this.addTweakModuleSlider({
            text: "value2",
            minValue: 50,
            maxValue: 1000,
            startValue: this._tweakValue2,
            onValueChangeCallback: (text, newValue) => this.onTweakValue2Changed(newValue)
        });
    }
    onTweakValue1Changed(newValue) {
        this._tweakValue1 = newValue;
        Logger_1.Logger.logDev(`GameTweakerTest.onTweakValue1Changed() newValue = ${this._tweakValue1}`);
    }
    onTweakValue2Changed(newValue) {
        this._tweakValue2 = newValue;
        Logger_1.Logger.logDev(`GameTweakerTest.onTweakValue2Changed() newValue = ${this._tweakValue2}`);
    }
}
exports.GameTweakerTest = GameTweakerTest;
//# sourceMappingURL=GameTweakerTest.js.map